import React, { useEffect } from "react";
import { useRef } from "react";
import {
  Map,
  InfoWindow,
  Marker,
  GoogleApiWrapper,
  OverlayView,
} from "google-maps-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ToggleButton } from "@mui/material";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import PinIcon from "../../common/images-new/pin-icon.svg";
import { staticFiles } from "../../components/Helpers/Static";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import {
  convertDateFormat,
  htmlToText,
  trimString,
  tokenAuthorize,
  removeIframe,
  removeImage,
} from "../../components/Helpers/Common";
import { getUrl } from "../../components/Helpers/Config";
import {
  ActiveIconColor,
  ButtonCommonTopNew,
  Card,
  ButtonCommonDelete,
  ButtonCommonTopGrey,
} from "../Theme";
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from "react-icons/ai";
import { PiMapPinFill } from "react-icons/pi";

const containerStyle = {
  width: "100%",
  height: "100%",
};
const NO_IMAGE = staticFiles.noImage;
function GoogleMap() {
  const [activeMarker, setActiveMarker] = useState({});
  const [selectedPlace, setSelectedPlace] = useState({});
  const [showingInfoWindow, setShowingInfoWindow] = useState(false);
  const centerPoint = { lat: Number("36.204824"), lng: Number("138.252924") };
  const refs = useRef({});
  const locations = useSelector((state) => state.showcase.locations);
  const [google, setGoogle] = useState(null);
  const [isActive, setisActive] = useState(true);
  const [active, setActive] = useState("self");
  const [offset, setOffset] = useState(0);
  const userProfile = useSelector((state) => state.auth.user);
  const [isStudent, setisStudent] = useState(false);
  const [isTutor, setisTutor] = useState(false);
  const [mapFeed, setmapFeed] = useState([]);
  const [selectedFeed, setSelectedFeed] = useState([]);
  const [address, setAddress] = useState("");
  const [id, setid] = useState(null);
  const [image, setImage] = useState("");
  const [isChange, setIsChange] = useState(true);
  const history = useHistory();

  useEffect(() => {
    if (userProfile.role === "MANAGER") {
      setisTutor(true);
      setisStudent(false);
    }
    if (userProfile.role === "MEMBER") {
      setisTutor(false);
      setisStudent(true);
    }
  }, [userProfile]);

  useEffect(() => {
    if (isTutor || isStudent) {
      axios
        .get(
          serverUrl.Map +
            `feed?offset=${offset}&is_tutor=${isTutor}&is_student=${isStudent}&type=${active}`
        )
        .then((res) => {
          if (res.status === 200) {
            res?.data.forEach((data) => {
              return data;
            });
            setmapFeed(res?.data);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          console.log(err);
        });
    }
  }, [isTutor, isStudent, isChange]);

  const onMarkerClick = (props, marker, e) => {
    // setSelectedPlace(props)
    // mapFeed.forEach((data)=>{
    //     if(data.address===e.target.title)
    //     {
    //         data["isShow"]=!data["isShow"];

    //     }
    // })
    setSelectedPlace(props);
    setActiveMarker(marker);
    setShowingInfoWindow(true);
    const newFeed = mapFeed.filter((data) => {
      if (
        props.position.lat === Number(data.latitude) &&
        props.position.lng === Number(data.longitude)
      ) {
        return data;
      }
    });
    setid(newFeed[0].reflections[0].reflection_id);
    setAddress(newFeed[0].address);
    newFeed[0].reflections.forEach((data, index) => {
      data["reflection_content"] = removeImage(data["reflection_content"]);
    });
    setSelectedFeed(newFeed[0].reflections);
    // setSelectedFeed(mapFeed[index].reflections);
  };

  const onInfoWindowClose = (e, indx) => {
    setActiveMarker(null);
    setShowingInfoWindow(false);
    setSelectedFeed([]);
    setAddress("");
  };
  const [mapInstance, setMapInstance] = useState(null);

  const handleMapReady = (mapProps, map) => {
    setMapInstance(map);
  };

  useEffect(() => {
    if (id !== null) {
      axios
        .get(serverUrl.Map + `reflection_image/${id}`)
        .then((res) => {
          if (res.status === 200) {
            setImage(encodeURI(res?.data));
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          console.log(err);
        });
    }
  }, [id]);

  function addZero(val) {
    let start = val.toString().length > 1 ? val : "0" + val;
    return start;
  }

  function convertDate(oldDate) {
    let date = new Date(oldDate);
    let day = date.getDate();
    let mon = date.getMonth() + 1;
    let year = date.getFullYear();
    let hour = date.getHours();
    let min = date.getMinutes();
    let end = hour < 12 ? "AM" : "PM";
    let newDate =
      addZero(day) +
      "-" +
      addZero(mon) +
      "-" +
      year +
      " " +
      (hour <= 12 ? addZero(hour) : addZero(hour - 12)) +
      ":" +
      addZero(min) +
      " " +
      end;
    return newDate;
  }

  useEffect(() => {
    setActiveMarker(null);
    setShowingInfoWindow(false);
    setSelectedFeed([]);
    setAddress("");
    setmapFeed([]);
    setid(null);
    setIsChange(!isChange);
  }, [active]);

  const [isPanelOpen, setIsPanelOpen] = useState(true);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const groupedLocations = mapFeed?.reduce((acc, item) => {
    if (
      !item.address ||
      item.address.trim() === "" ||
      item.address === null ||
      !item.latitude ||
      item.latitude.trim() === "" ||
      item.latitude === null ||
      !item.longitude ||
      item.longitude.trim() === "" ||
      item.longitude === null
    ) {
      return acc;
    }

    const loc = item.address;
    // if (!acc[loc]) acc[loc] = [];

    // acc[loc] = [...acc[loc], ...item.reflections];
    // return acc;
    if (!acc[loc]) {
      acc[loc] = {
        latitude: item.latitude,
        longitude: item.longitude,
        reflections: [],
      };
    }

    acc[loc].reflections = [...acc[loc].reflections, ...item.reflections];

    return acc;
  }, {});

  useEffect(() => {
    if (selectedAddress && refs.current[selectedAddress]) {
      refs.current[selectedAddress].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedAddress]);

  const panToLocation = (lat, lng) => {
    if (mapInstance && lat && lng) {
      const google = window.google;
      const newCenter = new google.maps.LatLng(Number(lat), Number(lng));
      mapInstance.panTo(newCenter);
      mapInstance.setZoom(13);
    }
  };
  const smoothPanTo = (map, lat, lng, steps = 30, interval = 20) => {
    if (!map) return;

    const start = map.getCenter();
    const end = new window.google.maps.LatLng(lat, lng);

    let i = 0;

    const deltaLat = (end.lat() - start.lat()) / steps;
    const deltaLng = (end.lng() - start.lng()) / steps;

    const move = () => {
      i++;
      const lat = start.lat() + deltaLat * i;
      const lng = start.lng() + deltaLng * i;
      map.panTo(new window.google.maps.LatLng(lat, lng));

      if (i < steps) {
        setTimeout(move, interval);
      }
    };

    move();
  };

  const noProf =
    "https://images.pexels.com/photos/255379/pexels-photo-255379.jpeg?cs=srgb&dl=pexels-miguel-%C3%A1-padri%C3%B1%C3%A1n-255379.jpg&fm=jpg";
  const content =
    "Elit ullamcorper dignissim cras tincidunt lobortis feugiat vivamus. Vitae tempus quam pellentesque nec nam aliquam. Semper quis lectus nulla at volutpat diam ut. Orci phasellus egestas tellus rutrum tellus pellentesque.Elit ullamcorper dignissim cras tincidunt lobortis feugiat vivamus. Vitae tempus quam pellentesque nec nam aliquam. Semper quis lectus nulla at volutpat diam ut. Orci phasellus egestas tellus rutrum tellus pellentesque.";
  return (
    <div className="flex h-screen w-full">
      {/* Left Panel */}
      <div
        className={`transition-all duration-300 ease-in-out mapBackGroundColor shadow-lg overflow-y-auto 
      ${isPanelOpen ? "w-52 sm:w-72 md:w-4/12 p-3" : "w-0"} `}
      >
        {isPanelOpen && (
          <>
            <h2 className="text-lg font-bold mb-1">Reflections by Location</h2>
            {groupedLocations &&
              Object.entries(groupedLocations).map(([location, locData]) => (
                <div
                  key={location}
                  ref={(el) => (refs.current[location] = el)}
                  className={`p-3 rounded-xl ${
                    selectedAddress === location ? "bg-blue-100" : ""
                  }`}
                >
                  <h3 className="font-semibold text-base mb-2 flex gap-1 items-center">
                    <PiMapPinFill className="text-red-600" /> {location}
                  </h3>
                  <div className="space-y-3">
                    {locData.reflections.map((data, index) => (
                      <div
                        key={index}
                        className="bg-white rounded-xl shadow-md w-full cursor-pointer overflow-hidden"
                        onClick={() => {
                          panToLocation(locData.latitude, locData.longitude);
                        }}
                      >
                        {/* Card Image */}
                        {data.reflection_image ? (
                          <img
                            src={data.reflection_image}
                            alt={data.reflection_title}
                            className="w-full h-36 object-cover"
                          />
                        ) : (
                          <img
                            src={NO_IMAGE}
                            alt="No Image"
                            className="w-full h-36 object-cover"
                          />
                        )}

                        {/* Card Body */}
                        <div className="p-4">
                          <div className="text-sm font-bold text-black break-words overflow-hidden pb-2">
                            {data.reflection_title}
                          </div>
                          <div className="text-sm font-normal mb-3 overflow-hidden">
                            <div
                              className="multiline-ellipsis5"
                              dangerouslySetInnerHTML={{
                                __html: removeIframe(
                                  removeImage(data?.reflection_content)
                                ),
                              }}
                            />
                          </div>
                          <div className="flex items-center justify-end mt-2">
                            <span
                              // onClick={() => {
                              //   history.push(
                              //     getUrl("/post/") + data.reflection_id
                              //   );
                              // }}
                              onClick={() =>
                                window.open(
                                  getUrl("/post/") + data.reflection_id,
                                  "_blank"
                                )
                              }
                              className="blueColor text-xs "
                            >
                              Read more..
                            </span>
                          </div>

                          <div className="flex flex-row mt-2">
                            <a
                              className="nav-navigate font-semibold"
                              href={getUrl("/profile/") + data.reflection_guid}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <ActiveIconColor className="hover:underline text-xs">
                                {trimString(data.reflection_owner, 55)}
                              </ActiveIconColor>
                            </a>
                            <div className="flex justify-end w-full">
                              <p className="text-gray-500 text-xs">
                                {convertDateFormat(data.reflection_posted_date)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </>
        )}
      </div>

      {/* Map Area */}
      <div className="flex-1 relative">
        <Map
          containerStyle={containerStyle}
          google={window.google}
          zoom={10}
          initialCenter={{ lat: 1.372082067940902, lng: 103.87135304140541 }}
          disableDoubleClickZoom={false}
          streetViewControl={false}
          onReady={handleMapReady}
        >
          <div className="flex flex-row gap-5 w-1/4 relative top-16 lg:top-3 h-11  ml-auto mr-auto">
            <div
              className={
                isActive
                  ? "map-ButtonColor rounded p-3 text-white cursor-pointer text-center hover:opacity-90 font-bold w-24"
                  : "bg-white text-black rounded p-3 cursor-pointer text-center hover:opacity-90 font-bold w-24"
              }
              onClick={() => {
                setisActive(true);
                setActive("self");
              }}
            >
              Self
            </div>
            <div
              className={
                !isActive
                  ? "map-ButtonColor rounded p-3 text-white cursor-pointer text-center hover:opacity-90 font-bold w-24"
                  : "bg-white text-black rounded p-3 cursor-pointer text-center hover:opacity-90 font-bold w-24"
              }
              onClick={() => {
                setisActive(false);
                setActive("feed");
              }}
            >
              Feed
            </div>
          </div>

          <ButtonCommonTopNew
            onClick={() => {
              history.goBack();
            }}
            className="relative top-6 lg:-top-7 float-right right-4 cursor-pointer px-4 py-1 rounded-lg"
          >
            Close
          </ButtonCommonTopNew>

          {/* <AiOutlineClose className="w-6 h-6 relative top-6 lg:-top-8 float-right right-4 cursor-pointer hover:opacity-100 text-black" onClick={() => { history.goBack(); }} /> */}

          {mapFeed &&
            mapFeed.map(
              (data, index) =>
                !isNaN(Number(data.latitude)) &&
                !isNaN(Number(data.longitude)) && (
                  <Marker
                    onClick={() => {
                      setIsPanelOpen(true);
                      setSelectedAddress(data.address);
                    }}
                    position={{
                      lat: Number(data.latitude),
                      lng: Number(data.longitude),
                    }}
                    key={index}
                  />
                )
            )}
        </Map>
        <button
          onClick={() => setIsPanelOpen(!isPanelOpen)}
          className={`absolute top-3 ${
            isPanelOpen ? "left-4" : "left-6"
          } z-50 bg-white p-2 rounded-full shadow`}
          style={{ transform: "translateX(-50%)" }}
        >
          {isPanelOpen ? (
            <AiOutlineMenuFold className="map-panelColor text-xl" />
          ) : (
            <AiOutlineMenuUnfold className="map-panelColor text-xl" />
          )}
        </button>
      </div>
    </div>
  );
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDXgsxWEgtVWgZdU5W4htOoQgUOOVeYK1k",
})(GoogleMap);
